/** Reveal the app or its error page even if authentication never mounted. */
export function dismissStartupLoader(): void {
  if (typeof document === "undefined") return;
  document.body?.classList.remove("loading");
  document.dispatchEvent(new Event("tonesim:startup-ready"));
  const loader = document.getElementById("app-loading-screen");
  if (!loader || loader.classList.contains("hidden")) return;
  loader.classList.add("hidden");
  setTimeout(() => loader.remove(), 300);
}
